module.exports = __webpack_public_path__ + "nf.svg?1b0c40570e473a0b3c37011dd473fe25";